import { fromPairs as objectFromEntries } from 'lodash';

export default objectFromEntries;
